import { Notification, Select } from "@rio-cloud/rio-uikit"
import { FormEvent, useState } from "react"
import { editMaintenanceGroup } from "../../../../api/fetchMaintenanceGroup";
import { useIntl } from "react-intl";

interface IEditGroupSidebar {
    group: string;
    chassis: string;
    model?: string;
    setIsClosing: React.Dispatch<React.SetStateAction<boolean>>
    onSuccess: (newGroup?: string) => void
}

export const EditGroupSidebar = ({ group, chassis, model, setIsClosing, onSuccess }: IEditGroupSidebar) => {
  const [selectValue, setSelectValue] = useState(group);

  const intl = useIntl();
  const handleNewData = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const response = await editMaintenanceGroup(chassis, selectValue);

        if(response) {
            Notification.success(intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.success" }));
            setIsClosing(true)
            onSuccess(selectValue)
            return
        }

        Notification.error(intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.error" }));
  }

  return (
    <form className="" action="" onSubmit={handleNewData}>
        <div className="grid gap-7 [grid-template-columns:repeat(auto-fit,minmax(220px,1fr))]">
            <div className='form-group max-w-[262.3px]'>
                <label className='text-size-14 text-color-darker margin-bottom-10'>{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.maintenanceGroup" })}</label>
                <div className='justify-between flex flex-col'>
                    <Select
                        value={[selectValue]}
                        onChange={option => setSelectValue(option?.id || '')}
                        options={[
                            {id: '-', label: intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.select" })},
                            {id: '1', label: intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.roadway" })},
                            {id: '2', label: intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.mixed" })},
                            {id: '3', label: intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.severe" })},
                            {id: '4', label: intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.special" })},
                        ]}
                        placeholder={intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.select" })}
                        disabled={!model || group !== '-'}
                    />
                </div>
            </div>
        </div>

        {!model && group === '-' ? <div className="text-gray-500 dark:text-neutral-400 text-size-12 mb-5 w-full text-left">
            *{intl.formatMessage({ id: "intl-msg:occurrence.modelNotDefinedMessage" })}
        </div> : null}

        <div className={`justify-content-end ${!model || group !== '-' ? 'display-none' : 'display-flex'}`}>
            <button type='submit' className='btn btn-primary w-[257px]'>
                {intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.save" })}
            </button>
        </div>
    </form>
  )
}

export default EditGroupSidebar